// NPM Imports
import React, { Fragment } from "react";

// Internal Imports
import { NumberInput, Toastr } from "../../../revvComponents";
import { QtyNotifier } from "../Display/Renderer";

export default class RevvGridNumber extends React.Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.state = {
      cellValue: 0,
      localUpdate: false,
      showComponent: false,
    };
  }

  componentDidMount() {
    const { row, field } = this.props;
    const cellValue = row.rowData[field] ? row.rowData[field].cellData : "";
    this.setState({ cellValue });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { row, field } = nextProps;
    const cellValue = row.rowData[field] ? row.rowData[field].cellData : "";
    if (!prevState.localUpdate && cellValue !== prevState.cellValue) {
      return { cellValue };
    }
    return null;
  }

  _onChange = value => {
    this.setState({ cellValue: value, localUpdate: true });
  };

  _onBlur = () => {
    const { field, row } = this.props;
    const minValue =
      (row.rowData[field] &&
        row.rowData[field].cellMeta &&
        row.rowData[field].cellMeta.minValue) ||
      1;

    if (parseFloat(this.state.cellValue) >= minValue) {
      this.props.onChange(parseFloat(this.state.cellValue));
      this.setState({ showComponent: false, localUpdate: false });
    } else {
      this.setState({ cellValue: 1, showComponent: false, localUpdate: false });
      Toastr.showToastr({
        type: "warning",
        message: `Enter value greater or equal to ${minValue}`,
        timeout: 3000,
      });
    }
  };

  _decideComponent = (field, row) => {
    const isPopUp =
      row.rowData[field] &&
      row.rowData[field].cellMeta &&
      row.rowData[field].cellMeta.isPopUp;

    if (isPopUp) {
      this.setState({ showComponent: false });
      return this.props.pricingPopUp(this.state.cellValue);
    }

    return (
      <NumberInput
        autoFocus
        inputRef={this.textInput}
        onBlur={this._onBlur}
        onChange={this._onChange}
        onKeyPress={event => {
          if (event.key === "Enter") {
            this._onBlur();
          }
        }}
        placeholder="Enter Value"
        value={this.state.cellValue}
        data-test="rgnumber-number-input"
      />
    );
  };

  render() {
    const { field, row, ...otherProps } = this.props;
    const editable =
      row.rowData[field] &&
      row.rowData[field].cellMeta &&
      row.rowData[field].cellMeta.editable;

    const isPopUp =
      row.rowData[field] &&
      row.rowData[field].cellMeta &&
      row.rowData[field].cellMeta.isPopUp;
    return (
      <Fragment>
        {this.state.showComponent && this._decideComponent(field, row)}
        {!this.state.showComponent && (
          <QtyNotifier
            editable={editable}
            isPopUp={isPopUp}
            onClick={() => this.setState({ showComponent: true })}
            rowMeta={row.rowMeta}
            value={this.state.cellValue}
            {...otherProps}
          />
        )}
      </Fragment>
    );
  }
}
